import moment from 'moment';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@material-ui/core/AppBar';
import { useHistory } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { getAllInboxes, getAllMails, getAllCampaign, replyToUserEmail } from '../../store/Campaign';


import {
  Chip,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import ImageIcon from "@mui/icons-material/Image";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CodeIcon from "@mui/icons-material/Code";

import "react-datepicker/dist/react-datepicker.css";
import './index.css';


const initialCreate = {
  name: '',
  assistantId: '',
  createdBy: localStorage.getItem('userId') || '',
  phoneNumber: [],
  callsInterval: '',
  intervalTime: '',

};


// Dropdown options
const optionsStatusDetails = [
  // { value: "status", label: "Status", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "contact", label: "Contact", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Interested ", label: "Interested ", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#97E0B6" /></svg></> },
  { value: "Meeting-booked", label: "Meeting booked", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#BE83E4" /></svg></> },
  { value: "Meeting-completed", label: "Meeting completed", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#F1A842" /></svg></> },
  { value: "Won", label: "Won", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#CAE32B" /></svg></> },
  { value: "Out-of-office", label: "Out of office", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#93BCED" /></svg></> },
  { value: "Wrong-person", label: "Wrong person", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#A5AAB6" /></svg></> },
  { value: "Not-Interested", label: "Not Interested", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#EA7D84" /></svg></> },
  { value: "Lost", label: "Lost", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#FF0000" /></svg></> },
  { value: "Create-Lable", label: "Create Lable", icon: <><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.1665V15.8332" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.1665 10H15.8332" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];

const optionsMoreDetails = [
  { value: "To-subsequences", label: "To subsequences", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 12.75L15.75 9L12 5.25" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.75 9H6.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "To-another-campaign", label: "To another campaign", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 14.25C16.5 14.6478 16.342 15.0294 16.0607 15.3107C15.7794 15.592 15.3978 15.75 15 15.75H3C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V3.75C1.5 3.35218 1.65804 2.97064 1.93934 2.68934C2.22064 2.40804 2.60218 2.25 3 2.25H6.75L8.25 4.5H15C15.3978 4.5 15.7794 4.65804 16.0607 4.93934C16.342 5.22064 16.5 5.60218 16.5 6V14.25Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /><path d="M9.68799 12.8052L11.938 10.5552L9.68799 8.30518" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /><path d="M11.9381 10.5552H6.53809" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
];

// Dropdown options
const optionsStatus = [
  { value: "contact", label: "Contact", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Interested ", label: "Interested ", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#97E0B6" /></svg></> },
  { value: "Meeting-booked", label: "Meeting booked", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#BE83E4" /></svg></> },
  { value: "Meeting-completed", label: "Meeting completed", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#F1A842" /></svg></> },
  { value: "Won", label: "Won", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" fill="#CAE32B" /></svg></> },
];

const optionsCampaigns = [
  // { value: "status", label: "Status", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "eCom", label: "eCom | US | Jan 23, 2025" },
  { value: "blockchain ", label: "Blockchain Development | Malik Haroon" },
];

// const optionsInboxes = [
//   // { value: "status", label: "Status", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
//   { value: "abdul@softtik.online", label: "abdul@softtik.online" },
//   { value: "ammara@softtik.click ", label: "ammara@softtik.click" },
//   { value: "ammara@softtik.ink ", label: "ammara@softtik.ink" },
//   { value: "ammara@softtik.online ", label: "ammara@softtik.online" },
//   { value: "ammara@softtik.online ", label: "ammara@softtik.online" },
//   { value: "ayesha@softtik.click ", label: "ayesha@softtik.click" },
// ];

const optionsMore = [
  // { value: "status", label: "Status", icon: <><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 1.5L2.25 10.5H9L8.25 16.5L15.75 7.5H9L9.75 1.5Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round" /></svg></> },
  { value: "Inbox", label: "Inbox" },
  { value: "Unread-only", label: "Unread only" },
  { value: "Reminders-only", label: "Reminders only" },
  { value: "Scheduled-emails", label: "Scheduled emails" },
];


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const initialReplyCreate = { from: '', to: '', subject: '', snippet: '', threadId: '', messageId: '' }


const UniBox = (props) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [valueSeeMore, setValueSeeMore] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [to, setTo] = React.useState("jake.mccullagh66@gmail.com");
  const [inputValueSeeMore, setInputValueSeeMore] = useState('');
  const toggleDropDwon = () => setDropdownOpen((prevState) => !prevState);
  const [isVisibleReplyMail, setIsVisibleReplyMail] = useState(false);

  const [selected, setSelected] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const [selectedStatusDetails, setSelectedStatusDetails] = useState("");
  const [searchStatusDetails, setSearchStatusDetails] = useState("");
  const [openStatusDetails, setOpenStatusDetails] = useState(false);

  const [selectedCampaigns, setSelectedCampaigns] = useState("");
  const [searchCampaigns, setSearchCampaigns] = useState("");
  const [openCampaigns, setOpenCampaigns] = useState(false);

  const [selectedInboxes, setSelectedInboxes] = useState("");
  const [searchInboxes, setSearchInboxes] = useState("");
  const [openInboxes, setOpenInboxes] = useState(false);

  const [selectedStatusMail, setSelectedStatusMail] = useState("");
  const [searchStatusMail, setSearchStatusMail] = useState("");
  const [openStatusMail, setOpenStatusMail] = useState(false);

  const [selectedMoreDetails, setSelectedMoreDetails] = useState("");
  const [searchMoreDetails, setSearchMoreDetails] = useState("");
  const [openMoreDetails, setOpenMoreDetails] = useState(false);

  const filteredStatuses = optionsMore.filter((status) =>
    status.label.toLowerCase().includes(search.toLowerCase())
  );

  const filteredoptionsStatusDetails = optionsStatus.filter((status) =>
    status.label.toLowerCase().includes(searchStatusDetails.toLowerCase())
  );

  // const filteredoptionsCampaigns = optionsCampaigns.filter((status) =>
  //   status.label.toLowerCase().includes(searchCampaigns.toLowerCase())
  // );

  // const filteredoptionsInboxes = optionsInboxes.filter((status) =>
  //   status.label.toLowerCase().includes(searchInboxes.toLowerCase())
  // );

  const filteredoptionsStatusMail = optionsStatusDetails.filter((status) =>
    status.label.toLowerCase().includes(searchStatusMail.toLowerCase())
  );

  const filteredoptionsMoreDetails = optionsMoreDetails.filter((status) =>
    status.label.toLowerCase().includes(searchMoreDetails.toLowerCase())
  );
  const [inboxes, setInboxes] = useState([]);
  const allInbox = useSelector(st => st.Campaign.allInboxes);

  const [mails, setMails] = useState([]);
  const allMails = useSelector(st => st.Campaign.allMails);
  const { allCampaign, campaignLogs } = useSelector(st => st.Campaign);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);

  useEffect(() => {
    dispatch(getAllInboxes());
  }, []);
  useEffect(() => {
    if (allInbox) setInboxes(allInbox); // Store fetched campaigns
  }, [allInbox]);
  console.log("inboxes", inboxes[0]?.email);

  useEffect(() => {

    if (selectedInboxes) {
      dispatch(getAllMails({ email: selectedInboxes }));
    }
    else {
      setSelectedInboxes(inboxes[0]?.email);
    }
  }, [selectedInboxes]);

  useEffect(() => {
    if (allMails) setMails(allMails); // Store fetched campaigns
  }, [allMails]);

  // console.log(mails, "Mails");

  useEffect(() => {
    dispatch(getAllCampaign());
  }, []);

  useEffect(() => {
    if (allCampaign) setCampaigns(allCampaign); // Store fetched campaigns
  }, [allCampaign]);

  const handleSendingReplies = (e) => {
    console.log("Reply data state:", selectedEmail);
    dispatch(replyToUserEmail({
      data: { ...selectedEmail },
      successCallback: () => {
        setSelectedEmail(initialReplyCreate)
        console.log("Reply Sent successful");
      },
      failCallback: () => {
        console.log("Sending reply failed");
      },
    })
    );

  };

  const filteredInboxes = inboxes.filter((inbox) =>
    inbox.email.toLowerCase().includes(searchInboxes.toLowerCase())
  );
  const filteredoptionsCampaigns = campaigns.filter((campaign) =>
    campaign.name.toLowerCase().includes(searchCampaigns.toLowerCase())
  );
  const handleEmailClick = (email) => {
    setSelectedEmail(email);
  };
  console.log(selectedEmail, "selected");
  const handleSelectInbox = (email) => {
    setSelectedInboxes(email);
    // setOpenInboxes(false);
  };
  const handleSelectStatue = (value) => {
    setSelected(value);
    setSearch("");
    setOpen(false);
  };

  const handleSelectStatuesDetails = (value) => {
    setSearchStatusDetails("");
    setOpenStatusDetails(false);
    setSelectedStatusDetails(value);
  };

  const handleSelectchCampaigns = (value) => {
    setSearchCampaigns("");
    setOpenCampaigns(false);
    setSelectedCampaigns(value);
  };

  const handleSelectchInboxes = (value) => {
    setSearchInboxes("");
    setOpenInboxes(false);
    setSelectedInboxes(value);
  };

  const handleSelectchStatusMail = (value) => {
    setSearchStatusMail("");
    setOpenStatusMail(false);
    setSelectedStatusMail(value);
  };

  const handleSelectchMoreDetails = (value) => {
    setSearchMoreDetails("");
    setOpenMoreDetails(false);
    setSelectedMoreDetails(value);
  };

  const handleTabsSet = (event, newValue) => {
    setValue(newValue);
  };

  return (

    <div className='content'>
      <div className='allemails-area unibox-page'>
        <h3>Filters</h3>

        <div className='filts-area'>
          <div className='filts-box'>
            <FormControl fullWidth>
              <Select
                open={openStatusDetails}
                onOpen={() => setOpenStatusDetails(true)}
                onClose={() => setOpenStatusDetails(false)}
                value={selectedStatusDetails}
                onChange={(e) => handleSelectStatuesDetails(e.target.value)} MoreDetails
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return "Select Status"; // Show placeholder when nothing is selected

                  const selectedOption = optionsStatus.find((option) => option.label === selected);

                  return selectedOption ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <i style={{ marginRight: "6px" }}>{selectedOption.icon}</i>
                      <Typography sx={{ fontSize: "14px" }}>{selectedOption.label}</Typography>
                    </Box>
                  ) : null;
                }}
                MenuProps={{
                  disableAutoFocusItem: true, // Prevent auto-focus issue
                }}
              >
                {/* Search Field - Keeps Dropdown Open on Click */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Search..."
                    value={searchStatusDetails}
                    onChange={(e) => setSearchStatusDetails(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                    autoFocus
                  />
                </MenuItem>

                {/* Show Filtered Options */}
                {filteredoptionsStatusDetails.length > 0 ? (
                  filteredoptionsStatusDetails.map((status) => (
                    <MenuItem key={status.label} value={status.label} onClick={() => handleSelectStatuesDetails(status.label)}>
                      <i style={{ marginRight: '10px' }}>{status.icon}</i> {status.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
          <div className='filts-box'>
            <FormControl fullWidth>
              <Select
                open={openCampaigns}
                onOpen={() => setOpenCampaigns(true)}
                onClose={() => setOpenCampaigns(false)}
                value={selectedCampaigns || ""}
                onChange={(e) => handleSelectchCampaigns(e.target.value)}
                displayEmpty
                renderValue={(selected) => (selected ? selected : "All Campaigns")}
                MenuProps={{ disableAutoFocusItem: true }}
              >
                {/* Search Field - Keeps Dropdown Open on Click */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Search..."
                    value={searchCampaigns}
                    onChange={(e) => setSearchCampaigns(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing
                    autoFocus
                  />
                </MenuItem>


                {/* Filtered Campaigns */}
                {filteredoptionsCampaigns.length > 0 ? (
                  filteredoptionsCampaigns.map((campaign) => (
                    <MenuItem key={campaign.id} value={campaign.name}>
                      {campaign.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>

          <div className='filts-box'>
            <FormControl fullWidth>
              <Select
                open={openInboxes}
                onOpen={() => setOpenInboxes(true)}
                onClose={() => setOpenInboxes(false)}
                value={selectedInboxes || ""}
                onChange={(e) => handleSelectInbox(e.target.value)}
                displayEmpty
                renderValue={(selected) => (selected ? selected : "All Inboxes")}
                MenuProps={{ disableAutoFocusItem: true }}
              >
                {/* Search Field - Keeps Dropdown Open on Click */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Search..."
                    value={searchInboxes}
                    onChange={(e) => setSearchInboxes(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing
                    autoFocus
                  />
                </MenuItem>

                {/* Show Filtered Emails */}
                {filteredInboxes.length > 0 ? (
                  filteredInboxes.map((inbox) => (
                    <MenuItem
                      key={inbox.id}
                      value={inbox.email}
                      onClick={() => handleSelectInbox(inbox.email)}
                    >
                      {inbox.email}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

          </div>
          <div className='filts-box'>
            <FormControl fullWidth>
              <Select
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                value={selected ? selected.label : ""}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return "More"; // Show placeholder when nothing is selected

                  const selectedOption = optionsMore.find((option) => option.label === selected);

                  return selectedOption ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <i style={{ marginRight: "6px" }}>{selectedOption.icon}</i>
                      <Typography sx={{ fontSize: "14px" }}>{selectedOption.label}</Typography>
                    </Box>
                  ) : null;
                }}
                MenuProps={{
                  disableAutoFocusItem: true, // Prevent auto-focus issue
                }}
              >
                {/* Search Field - Keeps Dropdown Open on Click */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    variant="standard"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                    autoFocus
                  />
                </MenuItem>

                {/* Show Filtered Options */}
                {filteredStatuses.length > 0 ? (
                  filteredStatuses.map((status) => (
                    <MenuItem key={status.label} value={status.label} onClick={() => handleSelectStatue(status.label)}>
                      {status.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className='email-box-area'>
          <div className="content-wrapper">
            <div className="email-wrapper">
              <div className="row align-items-stretch">
                <div className="mail-list-container col-md-3 pt-4 pb-4 border-right bg-white">
                  <AppBar position="static">
                    <Tabs value={value} onChange={handleTabsSet} aria-label="simple tabs example">
                      <Tab label="Primary" />
                      <Tab label="Others" />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={value} index={0}>
                    <div className="border-bottom pb-4 mb-3 px-3">
                      <div className='searchbox'>
                        <i className='icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_224_579)">
                              <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                            </g>
                            <defs>
                              <clipPath id="clip0_224_579">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                        <TextField
                          fullWidth
                          hiddenLabel
                          placeholder='Search...'
                          variant="standard"
                          size="small"
                          name='search'
                        />
                      </div>
                    </div>

                    <div className="left-mail-area">
                      {mails.length > 0 ? (
                        mails.map((mail, index) => (
                          <div className="mail-list new_mail">

                            <div key={index} onClick={() => { handleEmailClick(mail); setIsVisibleReplyMail(false); }}
                              style={{ cursor: "pointer", padding: "10px", borderBottom: "1px solid var(--sa-dark-border)" }}>
                              <div className='date-area'>
                                <i className='icon'>
                                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.75 0.5L0.25 9.5H7L6.25 15.5L13.75 6.5H7L7.75 0.5Z" fill="#94C5FA" />
                                  </svg>
                                </i>
                                <p className='date'>{mail.date
                                  ? new Intl.DateTimeFormat('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true, // 12-hour format (AM/PM)
                                  }).format(new Date(mail.date))
                                  : "No Date" || "No Date"}</p>
                              </div>
                              <div className="form-check">
                                <label className="form-check-label">
                                  <Checkbox />
                                  {mail.from || "Not Found"}
                                </label>
                              </div>
                              <div className="content">
                                <p className="sender-name">{mail.subject || "Unknown Sender"}</p>
                                <p className="message_text">{mail.snippet || "No Content"}</p>
                              </div>
                              <div className="details">
                                <i className="mdi mdi-star-outline"></i>
                              </div>
                            </div>
                          </div>

                        ))
                      ) : (
                        <div className="mail-list new_mail">
                          <p className="text-center text-muted">No emails found</p>
                        </div>

                      )}
                    </div>
                  </TabPanel>

                  <TabPanel value={value} index={1}>
                    <div className="border-bottom pb-4 mb-3 px-3">
                      <div className='searchbox'>
                        <i className='icon'>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_224_579)">
                              <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                            </g>
                            <defs>
                              <clipPath id="clip0_224_579">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </i>
                        <TextField
                          fullWidth
                          hiddenLabel
                          placeholder='Search...'
                          variant="standard"
                          size="small"
                          // value={editState?.type || agentData?.type || ''}
                          // onChange={handleEditChange}
                          name='search'
                        />
                      </div>
                    </div>
                    <div className="left-mail-area">
                      {mails.length > 0 ? (
                        mails.map((mail, index) => (
                          <div className="mail-list new_mail" key={index} onClick={() => { handleEmailClick(mail); setIsVisibleReplyMail(false); }}
                            style={{ cursor: "pointer", padding: "10px", borderBottom: "1px solid var(--sa-dark-border)" }}
                          >

                            <div key={index}>
                              <div className='date-area'>
                                <i className='icon'>
                                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.75 0.5L0.25 9.5H7L6.25 15.5L13.75 6.5H7L7.75 0.5Z" fill="#94C5FA" />
                                  </svg>
                                </i>
                                <p className='date'>{mail.date
                                  ? new Intl.DateTimeFormat('en-US', {
                                    year: 'numeric',
                                    month: 'short',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true, // 12-hour format (AM/PM)
                                  }).format(new Date(mail.date))
                                  : "No Date" || "No Date"}</p>
                              </div>
                              <div className="form-check">
                                <label className="form-check-label">
                                  <Checkbox />
                                  {mail.from || "Not Found"}
                                </label>
                              </div>
                              <div className="content">
                                <p className="sender-name">{mail.subject || "Unknown Sender"}</p>
                                <p className="message_text">{mail.snippet || "No Content"}</p>
                              </div>
                              <div className="details">
                                <i className="mdi mdi-star-outline"></i>
                              </div>
                            </div>
                          </div>

                        ))
                      ) : (
                        <div className="mail-list new_mail">
                          <p className="text-center text-muted">No emails found</p>
                        </div>

                      )}
                    </div>
                  </TabPanel>
                </div>
                <div className="mail-view d-none d-md-block col-md-9 col-lg-9 bg-white">
                  <div className="message-body">
                    {/* Empty Inbox Show this */}
                    {/* <div className='empty-inbox'>
                      <div className='img-box'>
                        <svg width="262" height="263" viewBox="0 0 262 263" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M43.6668 44.1667H218.333C230.342 44.1667 240.167 53.9917 240.167 66.0001V197C240.167 209.008 230.342 218.833 218.333 218.833H43.6668C31.6585 218.833 21.8335 209.008 21.8335 197V66.0001C21.8335 53.9917 31.6585 44.1667 43.6668 44.1667Z" stroke="#F2F2F2" strokeWidth="8" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M240.167 66L131 142.417L21.8335 66" stroke="#F2F2F2" strokeWidth="8" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    </div> */}

                    {/* Email Show here */}
                    <div className="sender-details">
                      <span className='sender-name-word'>J</span>
                      <div className="details">
                        <p className="msg-subject">
                          {selectedEmail?.from || "not Found"}
                        </p>
                        <div className='filtes-details'>
                          <div className='filts-area'>
                            <div className='left-area'>
                              <div className='filts-box'>
                                <FormControl fullWidth>
                                  <Select
                                    open={openStatusMail}
                                    onOpen={() => setOpenStatusMail(true)}
                                    onClose={() => setOpenStatusMail(false)}
                                    value={selectedStatusMail}
                                    onChange={(e) => handleSelectchStatusMail(e.target.value)}
                                    displayEmpty
                                    renderValue={(selectedStatusMail) =>
                                      selectedStatusMail ? optionsStatusDetails.find((s) => s.label === selectedStatusMail)?.label : "Status"
                                    }
                                    MenuProps={{
                                      disableAutoFocusItem: true, // Prevent auto-focus issue
                                    }}
                                  >
                                    {/* Search Field - Keeps Dropdown Open on Click */}
                                    <MenuItem disableRipple>
                                      <TextField
                                        fullWidth
                                        variant="standard"
                                        placeholder="Search..."
                                        value={searchStatusMail}
                                        onChange={(e) => setSearchStatusMail(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                                        autoFocus
                                      />
                                    </MenuItem>

                                    {/* Show Filtered Options */}
                                    {filteredoptionsStatusMail.length > 0 ? (
                                      filteredoptionsStatusMail.map((status) => (
                                        <MenuItem key={status.label} value={status.label} onClick={() => handleSelectchStatusMail(status.label)}>
                                          <i style={{ marginRight: '10px' }}>{status.icon}</i> {status.label}
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem disabled>No results found</MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              </div>
                            </div>
                            <div className='right-area'>
                              <div className='filts-box'>
                                <FormControl fullWidth>
                                  <Select
                                    open={openMoreDetails}
                                    onOpen={() => setOpenMoreDetails(true)}
                                    onClose={() => setOpenMoreDetails(false)}
                                    value={selectedMoreDetails}
                                    onChange={(e) => handleSelectchMoreDetails(e.target.value)}
                                    displayEmpty
                                    renderValue={(selectedMoreDetails) =>
                                      selectedMoreDetails ? optionsMoreDetails.find((s) => s.label === selectedMoreDetails)?.label : "More"
                                    }
                                    MenuProps={{
                                      disableAutoFocusItem: true, // Prevent auto-focus issue
                                    }}
                                  >
                                    {/* Search Field - Keeps Dropdown Open on Click */}
                                    <MenuItem disableRipple>
                                      <TextField
                                        fullWidth
                                        variant="standard"
                                        placeholder="Search..."
                                        value={searchMoreDetails}
                                        onChange={(e) => setSearchMoreDetails(e.target.value)}
                                        onClick={(e) => e.stopPropagation()} // Prevent dropdown from closing on click
                                        autoFocus
                                      />
                                    </MenuItem>

                                    {/* Show Filtered Options */}
                                    {filteredoptionsMoreDetails.length > 0 ? (
                                      filteredoptionsMoreDetails.map((status) => (
                                        <MenuItem key={status.label} value={status.label} onClick={() => handleSelectchMoreDetails(status.label)}>
                                          <i style={{ marginRight: '10px' }}>{status.icon}</i> {status.label}
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem disabled>No results found</MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              </div>
                              <div className='filts-box style-two'>
                                <button className='download-csv'>
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.6668 1.6665H5.00016C4.55814 1.6665 4.13421 1.8421 3.82165 2.15466C3.50909 2.46722 3.3335 2.89114 3.3335 3.33317V16.6665C3.3335 17.1085 3.50909 17.5325 3.82165 17.845C4.13421 18.1576 4.55814 18.3332 5.00016 18.3332H15.0002C15.4422 18.3332 15.8661 18.1576 16.1787 17.845C16.4912 17.5325 16.6668 17.1085 16.6668 16.6665V6.6665L11.6668 1.6665Z" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.6665 1.6665V6.6665H16.6665" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.3332 10.8335H6.6665" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M13.3332 14.1665H6.6665" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.33317 7.5H7.49984H6.6665" stroke="#4b5563" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </button>
                              </div>
                              <div className='filts-box'>
                                <Dropdown className="create-btn" isOpen={dropdownOpen} toggle={toggleDropDwon}>
                                  <DropdownToggle>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.99984 10.8332C10.4601 10.8332 10.8332 10.4601 10.8332 9.99984C10.8332 9.5396 10.4601 9.1665 9.99984 9.1665C9.5396 9.1665 9.1665 9.5396 9.1665 9.99984C9.1665 10.4601 9.5396 10.8332 9.99984 10.8332Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M15.8333 10.8332C16.2936 10.8332 16.6667 10.4601 16.6667 9.99984C16.6667 9.5396 16.2936 9.1665 15.8333 9.1665C15.3731 9.1665 15 9.5396 15 9.99984C15 10.4601 15.3731 10.8332 15.8333 10.8332Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.16683 10.8332C4.62707 10.8332 5.00016 10.4601 5.00016 9.99984C5.00016 9.5396 4.62707 9.1665 4.16683 9.1665C3.70659 9.1665 3.3335 9.5396 3.3335 9.99984C3.3335 10.4601 3.70659 10.8332 4.16683 10.8332Z" stroke="var(--sa-dark-accent-light)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M15.7498 15.7498L12.4873 12.4873" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Find similar contacts</p>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M16.5 9H12L10.5 11.25H7.5L6 9H1.5" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M4.0875 3.8325L1.5 9V13.5C1.5 13.8978 1.65804 14.2794 1.93934 14.5607C2.22064 14.842 2.60218 15 3 15H15C15.3978 15 15.7794 14.842 16.0607 14.5607C16.342 14.2794 16.5 13.8978 16.5 13.5V9L13.9125 3.8325C13.7883 3.58259 13.5969 3.37228 13.3597 3.22521C13.1226 3.07814 12.8491 3.00015 12.57 3H5.43C5.15094 3.00015 4.87745 3.07814 4.64028 3.22521C4.40312 3.37228 4.21168 3.58259 4.0875 3.8325Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Mark as unread</p>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M13.875 1.87517C14.1734 1.5768 14.578 1.40918 15 1.40918C15.422 1.40918 15.8266 1.5768 16.125 1.87517C16.4234 2.17354 16.591 2.57821 16.591 3.00017C16.591 3.42213 16.4234 3.8268 16.125 4.12517L9 11.2502L6 12.0002L6.75 9.00017L13.875 1.87517Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Edit contact</p>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M9 4.5V9L12 10.5" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Set Reminder</p>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M12 15.75V14.25C12 13.4544 11.6839 12.6913 11.1213 12.1287C10.5587 11.5661 9.79565 11.25 9 11.25H3.75C2.95435 11.25 2.19129 11.5661 1.62868 12.1287C1.06607 12.6913 0.75 13.4544 0.75 14.25V15.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M6.375 8.25C8.03185 8.25 9.375 6.90685 9.375 5.25C9.375 3.59315 8.03185 2.25 6.375 2.25C4.71815 2.25 3.375 3.59315 3.375 5.25C3.375 6.90685 4.71815 8.25 6.375 8.25Z" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M17.25 8.25H12.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Delete contact / Add blocklist</p>
                                    </DropdownItem>
                                    <DropdownItem>
                                      <i className='icon'>
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M2.25 4.5H3.75H15.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M7.5 8.25V12.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                          <path d="M10.5 8.25V12.75" stroke="var(--text-color)" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </i>
                                      <p>Delete email</p>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>





                    <div className="message-content">
                      <div className='message-reply'>
                        {isVisibleReplyMail && (
                          < div className='message-content-reply'>
                            {/* Reply Show here */}
                            <div className="message-content">
                              <div className='message-reply'>
                                <Box
                                >
                                  <Typography variant="h6" sx={{ marginBottom: "8px" }}>
                                    Reply
                                  </Typography>

                                  {/* To Field */}
                                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mb: 2 }}>
                                    <Typography variant="body1">To</Typography>

                                    <TextField placeholder="Enter email address" value={selectedEmail?.from || ""} onChange={(e) => setSelectedEmail({ ...selectedEmail, to: e.target.value })} variant="outlined" size="small" InputProps={{ readOnly: true }} />
                                  </Box>
                                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mb: 2 }}>
                                    <Typography variant="body1">From</Typography>
                                    <Select
                                      fullWidth
                                      value={selectedEmail?.to}
                                      onChange={(e) => setSelectedEmail({ ...selectedEmail, from: e.target.value })}
                                      displayEmpty
                                      variant="outlined"
                                      size="small"
                                    >
                                      <MenuItem value={selectedEmail?.to} disabled>Select an email</MenuItem>
                                      {inboxes.map((inbox, index) => (
                                        <MenuItem key={index} value={inbox.email}>
                                          {inbox.email}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </Box>

                                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mb: 2 }}>
                                    <Typography variant="body1">Subject</Typography>
                                    {/* Subject Field */}
                                    <TextField
                                      hiddenLabel
                                      value={selectedEmail?.subject || ""}
                                      fullWidth
                                      variant="outlined"
                                      margin="dense"
                                      onChange={(e) => setSelectedEmail({ ...selectedEmail, subject: e.target.value })}
                                    />
                                  </Box>

                                  {/* Message Field */}
                                  <TextField
                                    hiddenLabel
                                    multiline
                                    rows={6}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    placeholder="Type # to add a macro"
                                    onChange={(e) => setSelectedEmail({ ...selectedEmail, snippet: e.target.value })}
                                  />

                                  {/* Formatting Toolbar */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      mt: 2,
                                      borderTop: "1px solid var(--sa-dark-border)",
                                      pt: 1,
                                    }}
                                  >
                                    <div className='btns-bottom-area'>
                                      <IconButton size="small">
                                        <FormatBoldIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <FormatItalicIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <FormatUnderlinedIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <StrikethroughSIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <FormatColorTextIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <InsertLinkIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <ImageIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <FormatListBulletedIcon />
                                      </IconButton>
                                      <IconButton size="small">
                                        <CodeIcon />
                                      </IconButton>
                                    </div>
                                    {/* <IconButton>
                                      <CloseIcon />
                                    </IconButton> */}
                                  </Box>
                                </Box>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className='message-reply-heading'>
                          <div className='title-area'>
                            <h5>{selectedEmail?.subject || "Unknown Sender"}</h5>
                            <p>{selectedEmail?.date
                              ? new Intl.DateTimeFormat('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true, // 12-hour format (AM/PM)
                              }).format(new Date(selectedEmail?.date))
                              : "No Date" || "No Date"}</p>
                          </div>
                          <div className='email-from'>
                            <div className='left-area'>
                              <p><b>From:</b>{selectedEmail?.from || "Unknown Sender"}</p>
                              <p><b>to: </b>{selectedEmail?.to || "muhammadnoumankhokhar52@gmail.com"}</p>
                            </div>
                            <div className='right-area'>
                              <button className='reply-btn'>
                                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.707 8.29279L11.707 0.292787C11.5671 0.152977 11.389 0.057771 11.195 0.0192035C11.0011 -0.0193641 10.8 0.000438951 10.6173 0.076109C10.4346 0.151779 10.2785 0.279918 10.1686 0.444328C10.0587 0.608738 10 0.802037 10 0.999787V4.54479C7.26829 4.79758 4.72923 6.06065 2.87969 8.08681C1.03015 10.113 0.00327173 12.7564 0 15.4998V16.9998C0.000157856 17.2074 0.0649097 17.4098 0.185274 17.5789C0.305639 17.748 0.475649 17.8755 0.671726 17.9436C0.867802 18.0118 1.08022 18.0172 1.27953 17.9592C1.47883 17.9011 1.65514 17.7825 1.784 17.6198C2.76385 16.4549 3.96594 15.4969 5.3201 14.8017C6.67426 14.1065 8.15334 13.6881 9.671 13.5708C9.721 13.5648 9.846 13.5548 10 13.5448V16.9998C10 17.1975 10.0587 17.3908 10.1686 17.5552C10.2785 17.7197 10.4346 17.8478 10.6173 17.9235C10.8 17.9991 11.0011 18.0189 11.195 17.9804C11.389 17.9418 11.5671 17.8466 11.707 17.7068L19.707 9.70679C19.8945 9.51926 19.9998 9.26495 19.9998 8.99979C19.9998 8.73462 19.8945 8.48032 19.707 8.29279ZM12 14.5858V12.4998C12 12.2346 11.8946 11.9802 11.7071 11.7927C11.5196 11.6051 11.2652 11.4998 11 11.4998C10.745 11.4998 9.704 11.5498 9.438 11.5848C6.74279 11.8328 4.17727 12.8568 2.052 14.5328C2.29324 12.3272 3.33954 10.2881 4.99055 8.80595C6.64157 7.32376 8.78128 6.50263 11 6.49979C11.2652 6.49979 11.5196 6.39443 11.7071 6.20689C11.8946 6.01936 12 5.765 12 5.49979V3.41379L17.586 8.99979L12 14.5858Z" fill="#4b5563" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className='message-body-inner'>
                          <p>{selectedEmail?.snippet || "Unknown Sender"}</p>
                          <p><br />Regards,<br />{selectedEmail?.from || "Unknown Sender"}<br />Thanks<br /></p>
                        </div>
                      </div>
                      {isVisibleReplyMail
                        ? <div className='footer-mail'>
                          <div className="row">
                            <div className="col-md-12 mb-4 mt-4">
                              <div className="btn-toolbar">
                                <div className="btn-group">
                                  <div className='reply-btns'>
                                    <button type="button" className="btn-style-new" onClick={() => {
                          
                                      handleSendingReplies(); // Call function properly
                                      setIsVisibleReplyMail(false);
                                    }}>Send</button>
                                    <button type="button" className="btn-style-new"><svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 1.25L4 4.75L7.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        : <div className='footer-mail'>
                          <div className="row">
                            <div className="col-md-12 mb-4 mt-4">
                              <div className="btn-toolbar">
                                <div className="btn-group">
                                  <div className='reply-btns'>
                                    <button type="button" className="btn-style-new" onClick={() => {
                                      setIsVisibleReplyMail(true);
                                    
                                    }}><i className="icon"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.337746 5.58746L5.00441 0.920792C5.08599 0.839237 5.18992 0.7837 5.30306 0.761202C5.4162 0.738704 5.53347 0.750256 5.64004 0.794397C5.74662 0.838538 5.83771 0.913286 5.90181 1.00919C5.96591 1.1051 6.00014 1.21785 6.00016 1.33321V3.40113C7.59366 3.54859 9.07478 4.28538 10.1537 5.46731C11.2326 6.64924 11.8316 8.19124 11.8335 9.79154V10.6665C11.8334 10.7876 11.7956 10.9057 11.7254 11.0043C11.6552 11.103 11.556 11.1774 11.4417 11.2171C11.3273 11.2569 11.2034 11.26 11.0871 11.2262C10.9708 11.1923 10.868 11.1231 10.7928 11.0282C10.2213 10.3487 9.52003 9.78986 8.73011 9.38433C7.94018 8.9788 7.07738 8.73471 6.19208 8.66629C6.16291 8.66279 6.09 8.65696 6.00016 8.65113V10.6665C6.00014 10.7819 5.96591 10.8947 5.90181 10.9906C5.83771 11.0865 5.74662 11.1612 5.64004 11.2054C5.53347 11.2495 5.4162 11.261 5.30306 11.2385C5.18992 11.2161 5.08599 11.1605 5.00441 11.079L0.337746 6.41229C0.228388 6.3029 0.166954 6.15456 0.166954 5.99988C0.166954 5.8452 0.228388 5.69685 0.337746 5.58746ZM4.8335 9.25838V8.04154C4.8335 7.88683 4.89495 7.73846 5.00435 7.62906C5.11375 7.51967 5.26212 7.45821 5.41683 7.45821C5.56558 7.45821 6.17283 7.48738 6.328 7.50779C7.9002 7.65249 9.39675 8.24981 10.6365 9.22746C10.4958 7.94088 9.88543 6.75141 8.92234 5.8868C7.95925 5.02219 6.71108 4.5432 5.41683 4.54154C5.26212 4.54154 5.11375 4.48008 5.00435 4.37069C4.89495 4.26129 4.8335 4.11292 4.8335 3.95821V2.74138L1.575 5.99988L4.8335 9.25838Z" fill="currentColor" /></svg></i> Reply</button>
                                    <button type="button" className="btn-style-new"><svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 1.25L4 4.75L7.5 1.25" stroke="white" stroke-linecap="round" stroke-linejoin="round" /></svg></button>
                                  </div>
                                  <button type="button" className="btn-style-border"><i className="icon"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6623 5.58746L6.99559 0.920792C6.91401 0.839237 6.81008 0.7837 6.69694 0.761202C6.5838 0.738704 6.46653 0.750256 6.35996 0.794397C6.25338 0.838538 6.16229 0.913286 6.09819 1.00919C6.03409 1.1051 5.99986 1.21785 5.99984 1.33321V3.40113C4.40634 3.54859 2.92522 4.28538 1.84632 5.46731C0.767427 6.64924 0.168412 8.19124 0.166504 9.79154V10.6665C0.166596 10.7876 0.204368 10.9057 0.27458 11.0043C0.344793 11.103 0.443966 11.1774 0.558344 11.2171C0.672722 11.2569 0.796635 11.26 0.912896 11.2262C1.02916 11.1923 1.132 11.1231 1.20717 11.0282C1.77875 10.3487 2.47997 9.78986 3.26989 9.38433C4.05982 8.9788 4.92262 8.73471 5.80792 8.66629C5.83709 8.66279 5.91 8.65696 5.99984 8.65113V10.6665C5.99986 10.7819 6.03409 10.8947 6.09819 10.9906C6.16229 11.0865 6.25338 11.1612 6.35996 11.2054C6.46653 11.2495 6.5838 11.261 6.69694 11.2385C6.81008 11.2161 6.91401 11.1605 6.99559 11.079L11.6623 6.41229C11.7716 6.3029 11.833 6.15456 11.833 5.99988C11.833 5.8452 11.7716 5.69685 11.6623 5.58746ZM7.1665 9.25838V8.04154C7.1665 7.88683 7.10505 7.73846 6.99565 7.62906C6.88625 7.51967 6.73788 7.45821 6.58317 7.45821C6.43442 7.45821 5.82717 7.48738 5.672 7.50779C4.0998 7.65249 2.60325 8.24981 1.3635 9.22746C1.50423 7.94088 2.11457 6.75141 3.07766 5.8868C4.04075 5.02219 5.28892 4.5432 6.58317 4.54154C6.73788 4.54154 6.88625 4.48008 6.99565 4.37069C7.10505 4.26129 7.1665 4.11292 7.1665 3.95821V2.74138L10.425 5.99988L7.1665 9.25838Z" fill="currentColor" /></svg></i>Forward</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      }

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default UniBox;

